/*
|--------------------------------------------------------------------------
| Guards
|--------------------------------------------------------------------------
|
| con los guards aplicamos una especie de middlewares sobre las rutas.
|
*/

// importamos nuestro store
import store from '@/store'

// para redireccionar si no esta logeado
const guest = (to, from, next) => {
    if(localStorage.getItem('user')){
      if(JSON.parse(localStorage.getItem('user')).active == 0){
        return next({
          name: 'Lock'
        })
      }     
    }     
    if(!store.getters['auth/authenticated']){
      return next({
        name: 'Login'
      })
    } 
    next()
}

// para redireccionar si ya esta logeado
const auth = (to, from, next) => {
    if(localStorage.getItem('user')){
      if(JSON.parse(localStorage.getItem('user')).active == 0){
        return next({
          name: 'Lock'
        })
      }     
    }     
    if(store.getters['auth/authenticated']){
      return next({
        path: '/'
      })
    } 
    next()
}

// para redireccionar si ya esta logeado
const inactive = (to, from, next) => {
    if(!localStorage.getItem('user')){
      return next({
        name: 'Login'
      })
    } 
    next()
}

export default {guest, auth, inactive}